import React from 'react'
import PropTypes from 'prop-types'
import Check from '@mui/icons-material/Check'

const CheckIcon = ({ height, width, ...more }) => {
	
	return (
		<Check
			height={height}
			width={width}
			{...more}
		/>
	)
}

CheckIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default CheckIcon
